/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Badge, BadgeVariety, Heading, Link, LinkHighlight, Text } from '@sonarsource/echoes-react';
import { FormattedMessage } from 'react-intl';
import { SharedDocLink, useSharedDocUrl } from '~adapters/helpers/docs';

interface JiraProjectBindingInfoProps {
  isProjectBound: boolean;
}

export default function JiraProjectBindingInfo({
  isProjectBound,
}: Readonly<JiraProjectBindingInfoProps>) {
  const docUrl = useSharedDocUrl();
  return (
    <>
      <Heading as="h2" className="sw-mb-6 sw-flex sw-items-center">
        <FormattedMessage id="project_settings.jira_binding.header" />
        <Badge
          className="sw-ml-2"
          variety={isProjectBound ? BadgeVariety.Success : BadgeVariety.Neutral}
        >
          <FormattedMessage
            id={
              isProjectBound
                ? 'project_settings.jira_binding.bound'
                : 'project_settings.jira_binding.not_bound'
            }
          />
        </Badge>
      </Heading>
      <FormattedMessage
        id={
          isProjectBound
            ? 'project_settings.jira_binding.description.bound'
            : 'project_settings.jira_binding.description.not_bound'
        }
        values={{
          p: (text) => (
            <Text as="p" className="sw-mb-4">
              {text}
            </Text>
          ),
          link: (text) => (
            <Link
              enableOpenInNewTab
              highlight={LinkHighlight.CurrentColor}
              to={docUrl(
                isProjectBound
                  ? SharedDocLink.JiraIntegrationTroubleshooting
                  : SharedDocLink.JiraIntegrationProjectBinding,
              )}
            >
              {text}
            </Link>
          ),
        }}
      />
    </>
  );
}
